import { Typography, Box, Button } from "@mui/material"
import { memo, useEffect, useState } from "react";
import {
    getOwners,
    getAnimalsByStatus,
    changeAnimalRegistrationCode,
} from "../../api/index.js";
import Spinner from "../../components/Spinner.js";
import { useSnackbar } from "../../utils/index.js";
import Form from "../../components/Form.js";
import useSelectStyles from "../../components/styles/Select.js";


const ChangeRegistrationCode = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);
    const [fetchedAnimals, setFetchedAnimals] = useState([])
    const [animalsDropdownValues, setAnimalsDropdownValues] = useState([])
    const [step, setStep] = useState(1);

    const { error, success } = useSnackbar();
    const classes = useSelectStyles();

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const { owners } = await getOwners();
            setFetchedOwners(owners);

            const dropdownValues = owners.map((owner) => ({
                value: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                text: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`
            }));
            setOwnersDropdownValues(dropdownValues);
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        fetchData();
    }, []);

    const fetchAnimals = async (ownerId) => {
        setIsLoading(true);
        try {
            const { animals } = await getAnimalsByStatus(ownerId, "alive");
            setFetchedAnimals(animals);

            const dropdownValues = animals.map((animal) => ({
                value: animal.registrationCode,
                text: animal.registrationCode
            }));
            setAnimalsDropdownValues(dropdownValues);
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    };

    const ownerFormContent = [
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Επιλογή εκτροφής",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Συνέχεια",
        },
    ]

    const changeRegistrationCodeFormContent = [
        {
            customType: "dropdown",
            id: "registrationCode",
            items: animalsDropdownValues,
            placeholder: "Επιλέξτε Ζώο",
            required: true,
        },
        {
            customType: "input",
            id: "newRegistrationCode",
            type: "text",
            placeholder: "Νέος Κωδικός Γενεαλογικού Βιβλίου",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ];

    const handleChangeAnimalRegistrationCode = async (values) => {
        setIsLoading(true);
        try {
            const animalId = fetchedAnimals.find((animal) => animal.registrationCode === values.registrationCode)?._id;
            const newRegistrationCode = values.newRegistrationCode.trim();
            const { success: scs, message } = await changeAnimalRegistrationCode(animalId, newRegistrationCode);
            if (scs) {
                success(message);
                setStep(1);
            } else {
                error(message);
            }
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    }
    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <Box className={classes.outerBox}>
                    <Box container flexDirection="column" className={classes.innerBox}>
                        <Typography variant="h5" sx={{ margin: "1rem" }}>
                            {"Επιλέξτε την Εκτροφή που σας ενδιαφέρει"}
                        </Typography>
                        <Form
                            title="Επιλογή Εκτροφής"
                            content={ownerFormContent}
                            onSubmit={async (values) => {
                                setIsLoading(true);
                                const owner = fetchedOwners.find((owner) => `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.owner);
                                if (owner) {
                                    await fetchAnimals(owner._id);
                                    setStep(2);
                                } else {
                                    error("Επιλέξτε έγκυρη εκτροφή");
                                }
                                setIsLoading(false);
                            }}
                        />
                    </Box>
                </Box>
            )}
            {step === 2 && (
                <Box className={classes.outerBox}>
                    <Box container flexDirection="column" className={classes.innerBox}>
                        <Typography variant="h5" sx={{ margin: "1rem" }}>
                            {"Επιλέξτε το Ζώο που σας ενδιαφέρει και εισάγετε τον νέο κωδικό γενεαλογικού βιβλίου"}
                        </Typography>
                        <Form
                            title="Αλλαγή Κωδικού Γενεαλογικού Βιβλίου"
                            content={changeRegistrationCodeFormContent}
                            onSubmit={(values) => handleChangeAnimalRegistrationCode(values)}
                        />
                        <Button
                            onClick={() => setStep(step - 1)}
                            sx={{
                                marginTop: "1rem",
                                padding: "0.5rem 1rem",
                                backgroundColor: "third",
                                color: "secondary.main",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                variant: "h5",
                            }}
                        >
                            Πίσω
                        </Button>
                    </Box>
                </Box>
            )}
        </>
    )
};

export default memo(ChangeRegistrationCode);